/**
 * @generated SignedSource<<b26fcfba1dc0e75d9d26d0500b8637c0>>
 * @relayHash 4f6dd79c512f29181fcb77a5e428e8ac
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f6dd79c512f29181fcb77a5e428e8ac

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreventionProgramDismissReason = "APPOINTMENT_ALREADY_BOOKED_THROUGH_MEDGATE" | "PATIENT_HAS_NO_INCREASED_RISK" | "PATIENT_IS_ALREADY_IN_PROGRAM" | "PATIENT_IS_NOT_INTERESTED" | "PATIENT_SELF_ORGANIZES";
export type PreventionProgramEngagementStatus = "BOOKED" | "DISMISSED";
export type Ch_savePreventionProgramEngagementsInput = {
  engagements: ReadonlyArray<Ch_preventionProgramEngagementInput>;
  patientId: string;
};
export type Ch_preventionProgramEngagementInput = {
  dismissReason?: PreventionProgramDismissReason | null;
  preventionProgramKey: string;
  status: PreventionProgramEngagementStatus;
};
export type chSavePreventionProgramEngagementsMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: Ch_savePreventionProgramEngagementsInput;
};
export type chSavePreventionProgramEngagementsMutation$data = {
  readonly savePreventionProgramEngagements: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly patientPreventionProgramOutput: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PatientPreventionProgramOutputFragment">;
    }> | null;
  };
};
export type chSavePreventionProgramEngagementsMutation = {
  response: chSavePreventionProgramEngagementsMutation$data;
  variables: chSavePreventionProgramEngagementsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "en",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "de",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chSavePreventionProgramEngagementsMutation",
    "selections": [
      {
        "alias": "savePreventionProgramEngagements",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_savePreventionProgramEngagementsPayload",
        "kind": "LinkedField",
        "name": "ch_savePreventionProgramEngagements",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientPreventionProgramOutput",
            "kind": "LinkedField",
            "name": "patientPreventionProgramOutput",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientPreventionProgramOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chSavePreventionProgramEngagementsMutation",
    "selections": [
      {
        "alias": "savePreventionProgramEngagements",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_savePreventionProgramEngagementsPayload",
        "kind": "LinkedField",
        "name": "ch_savePreventionProgramEngagements",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientPreventionProgramOutput",
            "kind": "LinkedField",
            "name": "patientPreventionProgramOutput",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedInstruction",
                "kind": "LinkedField",
                "name": "localizedInstruction",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dismissReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastUpdated",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "patientPreventionProgramOutput",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "addConnections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PreventionProgramsEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4f6dd79c512f29181fcb77a5e428e8ac",
    "metadata": {},
    "name": "chSavePreventionProgramEngagementsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d8589e596b2ac112e1e60fed31f4fcf4";

export default node;
